import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { NavDropdown } from "react-bootstrap";
import ParaLogo from "../assets/images/Para-Logo.png";
import ParaLogo1 from "../assets/images/Para-Logo1.png";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../store/login";
import { FaUser, FaSignOutAlt } from "react-icons/fa";
import { getUserInfo } from "../store/login";

const NavBar = () => {
  const [logoSrc, setLogoSrc] = useState(ParaLogo);

  const handleEvent = (x) => {
    if (x === 1) {
      setLogoSrc(ParaLogo);
    } else {
      setLogoSrc(ParaLogo1);
    }
  };

  const dispatch = useDispatch();

  const isLoggedIn = useSelector((state) => state.login.accessToken);
  const userName = useSelector((state) => state.login.username);
  const isCompany = useSelector((state) => state.login.isCompany);

  const handleLogout = () => {
    // Dispatch the logoutUser action when the "خروج" (Logout) option is clicked
    dispatch(logoutUser());
  };

  useEffect(() => {
    if (isLoggedIn) {
      // Fetch user info if accessToken exists
      dispatch(getUserInfo(isLoggedIn));
    }
  }, [isLoggedIn]);

  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Container fluid>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
            <LinkContainer to="/">
              <Nav.Link className=" text-xl me-5">صفحه نخست</Nav.Link>
            </LinkContainer>

            <NavDropdown
              title="سامانه‌ها"
              id="nav-dropdown-samaneha"
              className="mx-2 d-flex align-items-center"
              menuVariant="dark"
              align="end" // <-- Add this line
            >
              <LinkContainer to="/payesh">
                <NavDropdown.Item className="d-flex align-items-center justify-content-start text-white">
                  سامانه پایش کیفیت هوای محیطی
                </NavDropdown.Item>
              </LinkContainer>
              <LinkContainer to="/sound">
                <NavDropdown.Item className="d-flex align-items-center justify-content-start text-white">
                  سامانه پایش صوت محیطی
                </NavDropdown.Item>
              </LinkContainer>
              <LinkContainer to="/weather">
                <NavDropdown.Item className="d-flex align-items-center justify-content-start text-white">
                  سامانه پایش آنالایزرهای لحظه ای اتمسفر
                </NavDropdown.Item>
              </LinkContainer>
              <LinkContainer to="/stacks">
                <NavDropdown.Item className="d-flex align-items-center justify-content-start text-white">
                  سامانه پایش دودکش های صنایع
                </NavDropdown.Item>
              </LinkContainer>
            </NavDropdown>

            {isLoggedIn && isCompany ? (
              <LinkContainer to="/information">
                <Nav.Link className=" text-xl mx-2">
                  اطلاعات ایستگاه ها
                </Nav.Link>
              </LinkContainer>
            ) : (
              ""
            )}

            {isLoggedIn && isCompany ? (
              <LinkContainer to="/test">
                <Nav.Link className=" text-xl mx-2">دستگاه های تست</Nav.Link>
              </LinkContainer>
            ) : (
              ""
            )}

            {isLoggedIn && isCompany ? (
              <LinkContainer to="/comparison">
                <Nav.Link className=" text-xl mx-2">مقایسه داده ها</Nav.Link>
              </LinkContainer>
            ) : (
              ""
            )}

            {isLoggedIn ? (
              <NavDropdown
                title={
                  <p className="px-1 d-inline me-2  text-xl mx-2">
                    {" "}
                    <FaUser />
                    {userName ? `${userName}` : ""}
                  </p>
                }
                id="logOut"
              >
                <NavDropdown.Item
                  onClick={handleLogout}
                  className="px-2 text-xl"
                >
                  خروج{" "}
                  <span className="ml-2">
                    <FaSignOutAlt /> {/* Add your logout icon here */}
                  </span>
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <LinkContainer to="/login">
                <Nav.Link className=" text-xl mx-2">ورود</Nav.Link>
              </LinkContainer>
            )}
          </Nav>
        </Navbar.Collapse>
        <Navbar.Brand href="/" className=" navbarLogo">
          <img
            src={logoSrc}
            onMouseOver={() => handleEvent(0)}
            onMouseOut={() => handleEvent(1)}
            width="90"
            height="70"
            className="d-inline-block align-top"
            alt="PARA-Payesh"
          />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default NavBar;
